import { queryOptions } from '@tanstack/react-query';

import { userApi } from './api-handlers';
import { userQueryKeys } from './query-keys';

export const userQueryOptions = {
    getUserDataQueryOptions: () =>
        queryOptions({
            queryKey: userQueryKeys.current(),
            queryFn: () => userApi.getUserData(),
            staleTime: 30_000,
        }),
};
